import {CompanyInfoResponse, CompanySwitchResponseModel} from '@shared/models/companyInfo';

export class User {
  id: number;
  username: string;
  password: string;
  firstName?: string;
  lastName?: string;
  token?: string;
  email: string;
}

export class ForgotPasswordModel {
  email: string;
  baseUrl: string;
}

export interface TwoFaPhoneNumberModel {
  email?: string;
  phoneNumber?: string;
}

export interface TwoFaVerifyPhoneNumberModel extends TwoFaPhoneNumberModel {
  token: string;
}

export interface GetTokenResponseModel {
  otpRequired: boolean;
  token: string;
  refreshToken: string;
  permission: any;
  languageCode?: string;
  id: string;
  username: string;
  companies: CompanySwitchResponseModel[];
  selectedCompany: SelectedCompany;
  otpCooldownTime: string;
  availableProviders?: TwoFactorAuthenticationMethodsEnum[];
  defaultProvider?: TwoFactorAuthenticationMethodsEnum;
}


export interface JwtDecodedModel {
  /*
  *  Refer https://openid.net/specs/draft-jones-json-web-token-07.html
  */
  name: string;
  unique_name: string;
  nbf: number; // not before at in Unix epoch timestamp
  exp: number; // expiration at in Unix epoch timestamp
  iat: number; // issues at in Unix epoch timestamp
  ClientCode: string;
  CompanyId: string;
  CompanyName: string;
  EmployeeId: string;
  EmployeeName: string;
  EmployeeCode: string;
  DirectModule: number | string;
  ForceChangePassword: 'True' | 'False' | string;
  IsManager: 'True' | 'False' | string;
  sid: string;
  ModuleClaim: string[];
  SubModuleClaim?: string[];
  Storage: string;
  Role: UserRoles[];
}

export interface LoginModel {
  userName: string;
  password: string;
  isRemember: boolean;
  payRollYear: number;
  info?: CompanyInfoResponse;
}

export interface LoginResponse {
  userId: string;
  companies: CompanyInfoResponse[];
}

export interface SelectedCompany {
  id: string;
  code: string;
  email: string;
  role: string;
  companyname: string;
  companyId: string;
  storage: number;
  clientId?: any;
  clientCode: string;
  server: string;
  userName: string;
  password: string;
  loginedUserName?: any;
  payrollYear: number;
  modules: number[];
  subModules: number[];
  filters: any[];
}

export class SwitchCompanyModel {
  companyId: string;
  otp?: string;
  password: string;
  payrollYear: number;
}


export type UserRoles = 'Supervisor' | 'Admin' | 'Accountant' | string;

export enum TwoFactorAuthenticationMethodsEnum {
  SMS = 1,
  Email = 2
}
